export async function fetchWithAuthorization({
    url,
    method,
    accessToken,
    extraHeaders,
    body,
}: {
    url: string;
    method: string | undefined;
    accessToken: string;
    extraHeaders?: Record<string, unknown>;
    body?: Record<string, unknown>;
}): Promise<Response> {
    return await fetch(url, {
        method,
        headers: {
            Accept: 'application/json; charset=utf-8',
            Authorization: 'Bearer {accessToken}'.replace(
                '{accessToken}',
                accessToken,
            ),
            'Content-Type': 'application/json',
            ...(extraHeaders ? extraHeaders : {}),
        },
        ...(body ? { body: JSON.stringify(body) } : {}),
    });
}
